<template>
  <div :class="{'focus': onFocus,'align-center': $attrs.align ==='center'}" class="input-money">
    <span>{{ t('filter.currency') }}</span>
    <input
      v-model="value"
      @change="changeHandle"
      @blur="onFocus=false"
      @focus="focusHandle"
      class="form-control"
      type="number"
    ></input>
    <label><span v-if="$attrs.align ==='center'">{{ t('filter.currency') }}</span>{{ formatMoney(this.value) }}</label>
  </div>
</template>
<script>
import commonFunc from "../../assets/js/commonHelper";
export default {
  name: "MoneyInput",
  inheritAttrs: false,
  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 999999999,
    },
  },
  data() {
    return {
      onFocus: false,
    };
  },
  mounted() {
    this.value = this.value ? parseInt(this.value) : "";
  },
  methods: {
    formatMoney(val) {
      return commonFunc.formatMoney(val);
    },
    inputHandle() {
      if (this.value === "") {
        this.value = this.$attrs.min;
      }
      if (parseInt(this.value) > this.$attrs.max) {
        this.value = this.$attrs.max;
      }
    },
    focusHandle(e) {
      this.onFocus = true;
    },
    changeHandle(e) {
      this.$emit("change", this.value, e.target);
    },
  },
};
</script>
